// extracted by mini-css-extract-plugin
export default {"menu":"MoreActions_menu__mgSV+","menuItem__danger":"MoreActions_menuItem__danger__9xZ6m"};